import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import SeoPage from "@/pages/SeoPage";
import CollectionPage from "@/pages/CollectionPage";

/** Scroll to hash targets after route changes; otherwise start new pages at the top. */
const ScrollManager = () => {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        else if (attempt < 20) setTimeout(() => tryScroll(attempt + 1), 50);
      };
      tryScroll();
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [pathname, hash, key]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/services" element={<CollectionPage collection="services" />} />
          <Route path="/services/:slug" element={<SeoPage collection="services" />} />
          <Route path="/sectors" element={<CollectionPage collection="sectors" />} />
          <Route path="/sectors/:slug" element={<SeoPage collection="sectors" />} />
          <Route path="/fit-out" element={<CollectionPage collection="locations" />} />
          <Route path="/fit-out/:slug" element={<SeoPage collection="locations" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
